import {
  CREATE_BANK_DETAIL,
  DELETE_BANK_DETAIL,
  GET_BANK_DETAILS,
  BANK_DETAIL_REQUEST_FAILURE,
  BANK_DETAIL_REQUEST,
  UPDATE_BANK_DETAIL,
  GET_BANK_DETAILS_PAGE,
  BANK_DETAIL_REQUEST_SUCCESS
} from '../types';

const initialState = {
  bankDetails: [],
  bankDetailsPage: [],
  loading: false,
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  error: null,
};

const bankDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_DETAIL_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BANK_DETAILS:
      return {
        ...state,
        bankDetails: action.payload,
      };
    case GET_BANK_DETAILS_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        bankDetailsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_BANK_DETAIL:
      return {
        ...state,
        bankDetails: [action.payload, ...state.bankDetails],
        loading: false,
        error: null
      };
    case UPDATE_BANK_DETAIL:
      const bankDetailsData = state.bankDetails.slice(0);
      const uIndex = bankDetailsData.findIndex((data) => data.id === action.payload.id);
      bankDetailsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        bankDetails: [ ...bankDetailsData ],
        loading: false,
        error: null
      };
    case DELETE_BANK_DETAIL:
      const bankDetails = state.bankDetails?.slice(0);
      const index = bankDetails.findIndex((data) => data.id === action.id);
      if (index > -1) {
        bankDetails.splice(index, 1);
      }
      return {
        ...state,
        bankDetails: [...bankDetails],
        loading: false,
        error: null
      }
    case BANK_DETAIL_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case BANK_DETAIL_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default bankDetailReducer;
